// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.output-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
}

.output {
  /* background-color: #2d2d2d; */
  background-color: #1d1625;
  /* background-color: #feecec; */
  color: #cccccc;
  padding: 32px;
  flex: 1 1 auto;
  min-height: 0;
  border-top-color: black;
  border-top-width: 1px;
  /* margin-top: 56px; */

  h2 {
    font-size: 24px;
    font-weight: 700;
    display: inline-block;
    padding-right: 16px;
    color: #cccccc;
  }
}

.output-header {
  padding-bottom: 16px;
  display: flex;
  justify-content: space-between;

  button {
    margin-left: 8px;
  }  
}

.output > .output-header > h2 {
  font-size: 24px;
  font-weight: 700;
  display: inline-block;
  padding-right: 16px;
  color: #cccccc !important;
}

button {
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/components/output/output.css"],"names":[],"mappings":"AAAA;EAGE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;;EAEtB;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;EAChB;AACF;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,8BAA8B;;EAE9B;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".output-wrapper {\n  display: flex;\n  flex-direction: column;\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n}\n\n.output {\n  /* background-color: #2d2d2d; */\n  background-color: #1d1625;\n  /* background-color: #feecec; */\n  color: #cccccc;\n  padding: 32px;\n  flex: 1 1 auto;\n  min-height: 0;\n  border-top-color: black;\n  border-top-width: 1px;\n  /* margin-top: 56px; */\n\n  h2 {\n    font-size: 24px;\n    font-weight: 700;\n    display: inline-block;\n    padding-right: 16px;\n    color: #cccccc;\n  }\n}\n\n.output-header {\n  padding-bottom: 16px;\n  display: flex;\n  justify-content: space-between;\n\n  button {\n    margin-left: 8px;\n  }  \n}\n\n.output > .output-header > h2 {\n  font-size: 24px;\n  font-weight: 700;\n  display: inline-block;\n  padding-right: 16px;\n  color: #cccccc !important;\n}\n\nbutton {\n  display: inline-block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
